import { call, put, takeEvery } from 'redux-saga/effects';

import API from '../../api';
import { UpgradeRequestsActionTypes } from '../actions/types';
import {
  UpgradeRequestsActionCreators,
  TableActionCreators,
} from '../actions/creators';
import { AsyncActionStatus } from '../enums';
import { generateErrorMessage } from '../helpers';
import { Table } from '../../views/components';
import upgradeRequestsTableAPI from '../../views/pages/AllUpgrades/upgradeRequestsTableAPI';
import { tableXlsxExport, toast } from '../../utilities';

function* getUpgradeRequests(action) {
  try {
    const response = yield call(
      API.UpgradeRequests.getUpgradeRequests,
      action.payload.filters,
      action.payload.pagination,
      action.payload.sortBy,
    );
    yield put(UpgradeRequestsActionCreators.getUpgradeRequests[AsyncActionStatus.FULFILLED](response.data.requests));
    yield put(TableActionCreators.setPagination({
      pageIndex: response.data.pageIndex,
      pageSize: response.data.pageSize,
      pageCount: response.data.pageCount,
      rowsTotalCount: response.data.rowsTotalCount,
    }));
    yield put(TableActionCreators.setSortBy(
      Table.convertSortByForTable(response.data.sortBy, upgradeRequestsTableAPI.columnsFixtures),
    ));
  } catch (error) {
    const errorMessage = generateErrorMessage(error);
    toast.error(errorMessage);
    yield put(UpgradeRequestsActionCreators.getUpgradeRequests[AsyncActionStatus.REJECTED](errorMessage));
  }
}

function* getUpgradeRequestsForExcel(action) {
  try {
    const { filters, sortBy } = action.payload;
    const response = yield call(
      API.UpgradeRequests.getUpgradeRequestsForExcel,
      filters,
      sortBy,
    );
    tableXlsxExport(response.data.requests, 'Upgrade Requests', upgradeRequestsTableAPI);
    yield put(UpgradeRequestsActionCreators.getUpgradeRequestsForExcel[AsyncActionStatus.FULFILLED]());
  } catch (error) {
    yield put(UpgradeRequestsActionCreators.getUpgradeRequestsForExcel[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
  }
}

export default [
  takeEvery(
    UpgradeRequestsActionTypes.getUpgradeRequests[AsyncActionStatus.PENDING],
    getUpgradeRequests,
  ),
  takeEvery(
    UpgradeRequestsActionTypes.getUpgradeRequestsForExcel[AsyncActionStatus.PENDING],
    getUpgradeRequestsForExcel,
  ),
];

